import { Icon, IconProps } from '../Icon'

export const CurrencyExchangeIcon = ({ size, color }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      currency_exchange
    </Icon>
  )
}
